module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.options.youAd) ? _c('div', {
    staticClass: "g-hd hd-you"
  }, [_c('a', {
    attrs: {
      "href": _vm.options.youAd.url
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initFlag),
      expression: "initFlag"
    }],
    staticClass: "u-logo",
    attrs: {
      "src": _vm.options.youAd.img
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-hd"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initFlag),
      expression: "initFlag"
    }],
    staticClass: "u-logo",
    style: (this.options.logoSize),
    attrs: {
      "src": this.options.proLogo,
      "alt": "网易邮箱账号"
    },
    on: {
      "error": _vm.onLogoError
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "g-bd"
  }, [_c('Form', {
    ref: "form",
    staticClass: "m-form iptsBox"
  }, [_c('form-item', {
    staticClass: "m-ipt ipt-h",
    attrs: {
      "prop": "account"
    }
  }, [_c('suggest', {
    ref: "account",
    attrs: {
      "placeholder": "用户名",
      "name": "account",
      "suffix": _vm.options.suffixDomains,
      "initialValue": _vm.initialValue
    },
    on: {
      "focus": _vm.onClearMsg
    }
  })], 1), _vm._v(" "), _c('form-item', {
    staticClass: "m-ipt ipt-pwd",
    class: [_vm.capType == 1 ? 'ipt-m' : 'ipt-f'],
    attrs: {
      "prop": "pwd"
    }
  }, [_c('urs-pwdinput', {
    ref: "pwd",
    attrs: {
      "placeholder": "密码",
      "needEye": _vm.options.needEye
    },
    on: {
      "focus": _vm.onClearMsg,
      "delete": _vm.onClearMsg
    }
  })], 1), _vm._v(" "), (_vm.capType != 0) ? _c('form-item', {
    staticClass: "m-ipt ipt-f ipt-cap",
    class: _vm.capclazz,
    attrs: {
      "prop": "capture"
    }
  }, [_c('urs-capture', {
    ref: "capture",
    attrs: {
      "capKey": _vm.options.capKey,
      "aiCapKey": _vm.aiCapKey,
      "capType": _vm.capType,
      "opd": _vm.opd,
      "mail": _vm.getFullMail,
      "aicapbtn": _vm.aiCapBtn,
      "autoVerify": _vm.autoVerify
    },
    on: {
      "autoVerify": _vm.doAutoVerify,
      "verify": _vm.verifyCapture,
      "doVerifyLoading": _vm.doVerifyLoading,
      "doAiClose": _vm.doAiClose,
      "doVerify": _vm.doVerify,
      "initSucc": function($event) {
        _vm.onCapInit(1)
      },
      "initError": function($event) {
        _vm.onCapInit(0)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.repairlink) ? _c('div', {
    staticClass: "m-repair-guide"
  }, [_c('div', {
    staticClass: "x-box"
  }, [_c('a', {
    staticClass: "x"
  })]), _vm._v("多次输入错误，是否申请修复密码 "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.repairlink
    }
  }, [_vm._v("修复")])]) : _vm._e(), _vm._v(" "), (_vm.options.needUnLogin !== 0) ? _c('div', {
    staticClass: "u-clauses g-pd"
  }, [_c('div', {
    staticClass: "u-tips c-main"
  }, [_c('span', {
    on: {
      "click": _vm.onCheckBox
    }
  }, [_c('input', {
    ref: "unlogin",
    class: [_vm.checked ? 'checked i-checkbox' : 'i-checkbox'],
    attrs: {
      "type": "checkbox",
      "name": "unlogin"
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "i-check i-icon i-icon-check"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "unlogin"
    },
    on: {
      "click": _vm.onCheckBox
    }
  }, [_vm._v(_vm._s(_vm.unLoginTime) + "天免登录")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorTip),
      expression: "errorTip"
    }],
    staticClass: "errorTip"
  }, [_vm._v(_vm._s(_vm.errorTip))]), _vm._v(" "), _c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": _vm.nextbtntxt
    },
    on: {
      "click": _vm.onLogin
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-left",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.goFindPwd
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('a', {
    staticClass: "f-right",
    attrs: {
      "href": _vm.zcUrl
    }
  }, [_vm._v("去注册")])]), _vm._v(" "), (_vm.options.showMailAd) ? _c('div', {
    staticClass: "g-mail-ad c-main"
  }, [(_vm.options.showMailAd) ? _c('a', {
    attrs: {
      "href": _vm.mailUrl
    }
  }, [_vm._v("电脑版邮箱登录")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.options.showMailAd) ? _c('a', {
    attrs: {
      "href": "https://mail.163.com/dashi/dlpro.html?from=mail30"
    }
  }, [_vm._v("官方邮箱APP，提醒更及时>>")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('pre-account', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preAccount.length > 1),
      expression: "preAccount.length>1"
    }],
    attrs: {
      "account": _vm.preAccount
    },
    on: {
      "choose": _vm.fillAccount,
      "closeModal": _vm.closeModal
    }
  }), _vm._v(" "), _c('PowerCap', {
    ref: "powerCap",
    on: {
      "sucess": _vm.powerSuccess
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e59bc98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 515
// module chunks = 1